import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedOfferData, ITrackedOffer} from "./tracked_utils/tracked_offer";
import {getTrackedPropertyData, ITrackedProperty} from "./tracked_utils/tracked_property";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";
import {getTrackedVendorData, ITrackedVendor} from "./tracked_utils/tracked_vendor";

export const externalSiteClickAlgolytics = delayHit((payload: Object) => hitAlgolytics("external_site", payload), 500);

export const vendorViewExternalSiteClick = (vendor: ITrackedVendor) => {
    const payload = {
        view_type: "vendor",
        ...getTrackedSiteData(),
        ...getTrackedVendorData(vendor)
    };
    externalSiteClickAlgolytics(payload);
};

export const offerViewExternalSiteClick = (offer: ITrackedOffer, vendor: ITrackedVendor) => {
    const payload = {
        view_type: "offer",
        ...getTrackedSiteData(),
        ...getTrackedVendorData(vendor),
        ...getTrackedOfferData(offer)
    };
    externalSiteClickAlgolytics(payload);
};

export const propertyViewExternalSiteClick = (property: ITrackedProperty, offer: ITrackedOffer, vendor: ITrackedVendor) => {
    const payload = {
        view_type: "property",
        ...getTrackedSiteData(),
        ...getTrackedVendorData(vendor),
        ...getTrackedOfferData(offer),
        ...getTrackedPropertyData(property)
    };
    externalSiteClickAlgolytics(payload);
};
import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedOfferData, ITrackedOffer} from "./tracked_utils/tracked_offer";
import {getTrackedPropertyData, ITrackedProperty} from "./tracked_utils/tracked_property";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";
import {getTrackedVendorData, ITrackedVendor} from "./tracked_utils/tracked_vendor";

export const externalSiteClickAlgolytics = delayHit((payload: Object) => hitAlgolytics("external_site", payload), 500);

export const vendorViewExternalSiteClick = (vendor: ITrackedVendor) => {
    const payload = {
        view_type: "vendor",
        ...getTrackedSiteData(),
        ...getTrackedVendorData(vendor)
    };
    externalSiteClickAlgolytics(payload);
};

export const offerViewExternalSiteClick = (offer: ITrackedOffer, vendor: ITrackedVendor) => {
    const payload = {
        view_type: "offer",
        ...getTrackedSiteData(),
        ...getTrackedVendorData(vendor),
        ...getTrackedOfferData(offer)
    };
    externalSiteClickAlgolytics(payload);
};

export const propertyViewExternalSiteClick = (property: ITrackedProperty, offer: ITrackedOffer, vendor: ITrackedVendor) => {
    const payload = {
        view_type: "property",
        ...getTrackedSiteData(),
        ...getTrackedVendorData(vendor),
        ...getTrackedOfferData(offer),
        ...getTrackedPropertyData(property)
    };
    externalSiteClickAlgolytics(payload);
};
